import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // token
        // token: '',
        token: {
            accessToken: '',
            refreshToken: ''
        },
        // 权限数组
        permissions: [],
        // 登录名称
        loginName: '',
        userPhoto: '',
        realName: '',
        loginStaffId: '',
        bossId: null,
        iosUrl: 'https://apps.apple.com/cn/app/id1540722752',
        androidUrl: '',
        headerInfo: {
            isShowHeader: true,
            headerName: ''
        },
        activeIndex: '',
        drafs: [],
        messageNum: '',
        storeInfo: {
            storeName: '',
            storeId: '',
        },
        // 通知调用店铺
        storelist: '',
        socket: '',
        socketState: 0,
        staffId: null,
        logOutFlg: 0,
        // 经济看板type存储
        globlaViewType: 3,
        // 存储日期
        logisticsDate: [],
        riderStatisticsDate: [],
        sortingCenterDate: [],
        transferWarehouseDate: [],
        //存储审批点击
        approvalActive: "first",

    },
    mutations: {
        setLogisticsDate(state, logisticsDateValue) {
            if (logisticsDateValue) state.logisticsDate = logisticsDateValue
            
        },
        setRiderStatisticsDate(state, riderStatisticsDateValue) {
            if (riderStatisticsDateValue) state.riderStatisticsDate = riderStatisticsDateValue
        },
        setSortingCenterDate(state, sortingCenterDateValue) {
            if (sortingCenterDateValue) state.sortingCenterDate = sortingCenterDateValue
        },
        setTransferWarehouseDate(state, transferWarehouseDateValue) {
            if (transferWarehouseDateValue) state.transferWarehouseDate = transferWarehouseDateValue
        },


        setGloblaViewType(state, globlaViewType) {
            if (globlaViewType) {
                state.globlaViewType = globlaViewType;
            }
        },
        setStoreList(state, storelist) {
            if (storelist) {
                state.storelist = storelist;
            }
        },
        setActiveIndex(state, info) {
            if (info) {
                state.activeIndex = info;
            }
        },
        setHeaderInfo(state, info) {
            if (info) {
                if (info.isShowHeader === true) {
                    state.headerInfo.isShowHeader = info.isShowHeader
                    state.headerInfo.headerName = info.headerName
                    let infoStr = JSON.stringify(info)
                    localStorage.setItem('headerInfo', infoStr)
                } else {
                    state.headerInfo.isShowHeader = info.isShowHeader
                    state.headerInfo.headerName = ''
                    localStorage.setItem('headerInfo', infoStr)
                }
            }

        },
        setSocket(state, socket) {
            state.socket = socket
        },
        setSocketState(state, socketState) {
            state.socketState = socketState
        },
        setAndroidUrl(state, url) {
            state.androidUrl = url
            // localStorage.setItem('androidUrl', url)
        },
        // 登入 token
        setToken(state, token) {
            state.token = token
            // localStorage.setItem('token', token)
            localStorage.setItem('accessToken', token.accessToken)
            localStorage.setItem('refreshToken', token.refreshToken)

        },
        // 退出 token
        removeToken(state, token) {
            state.token = { accessToken: '', refreshToken: '' }
            // localStorage.clear()
            // sessionStorage.clear()
            localStorage.removeItem('refreshToken')
            localStorage.removeItem('loginName')
            localStorage.removeItem('accessToken')
            localStorage.removeItem('LogStaffId')
            // localStorage.removeItem('socketFlg', token.refreshToken)
            localStorage.removeItem('LogBossId')
            localStorage.removeItem('permissions')
            if (state.logOutFlg == 2) {
                localStorage.removeItem('storeInfo')
            }
        },
        // 存储权限数组
        setPermissions(state, arr) {
            state.permissions = arr
            localStorage.setItem('permissions', arr)
        },
        // 清除权限数组
        clearPermissions(state, arr) {
            state.permissions = arr
        },
        // 登录名称
        setLoginName(state, userName) {
            state.loginName = userName
            localStorage.setItem('loginName', userName)
        },
        // 登录店员的id
        setLoginStaffId(state, staffId) {
            state.loginStaffId = staffId
        },
        setLoginBossId(state, bossId) {
            state.bossId = bossId
        },
        // 清除登录名称
        clearLoginName(state, userName) {
            state.loginName = userName
        },
        // 设置店铺信息
        setStoreInfo(state, info) {
            state.storeInfo.storeName = info.storeName
            state.storeInfo.storeId = info.storeId
            let storeString = JSON.stringify(info)
            localStorage.setItem('storeInfo', storeString)
            console.log(localStorage.getItem('storeInfo'), 'storeInfo')
            console.log('设置set')

        },
        clearStoreInfo(state, storeInfo) {
            state.storeInfo.storeId = ''
            state.storeInfo.storeName = ''
            localStorage.setItem('storeInfo', '')
            console.log('清楚clear')


        },
        // 用户头像
        // setUserPhoto (state, userPhoto) {
        //   state.userPhoto = userPhoto
        //   localStorage.setItem('userPhoto', userPhoto)
        // },
        // 清除用户头像
        clearUserPhoto(state, userPhoto) {
            state.userPhoto = userPhoto
        },
        // 用户真名
        setRealName(state, realName) {
            state.realName = realName
            localStorage.setItem('realName', realName)
        },
        // 清除用户真名
        clearRealName(state, realName) {
            state.realName = realName
        },
        //设置草稿箱
        setDrafs(state, drafs) {
            state.drafs = drafs;
        },
        addDraf(state, data) {
            let index = -1;
            for (let i = 0; i < state.drafs.length; i++) {
                if (state.drafs[i].uuid == data.uuid) {
                    index = i;
                    break;
                }
            }
            if (index != -1) {
                state.drafs.splice(index, 1);
                state.drafs.push(data);
            } else {
                state.drafs.push(data);
            }
            window.localStorage.setItem('noticeDrafs', JSON.stringify(state.drafs))
        },
        removeDraf(state, uuid) {
            let index = -1;
            for (let i = 0; i < state.drafs.length; i++) {
                if (state.drafs[i].uuid == uuid) {
                    index = i;
                    break;
                }
            }
            if (index != -1) {
                state.drafs.splice(index, 1);
            }
            window.localStorage.setItem('noticeDrafs', JSON.stringify(state.drafs))
        },
        // 存储未读消息条数
        setMessageNum(state, num) {
            state.messageNum = num
            localStorage.setItem('messageNum', num)
        },
        // 清除未读消息条数
        removeMessageNum(state, num) {
            state.messageNum = 0
            localStorage.setItem('messageNum', 0)
        },
        setlogOutFlg(state, logOutFlg) {
            console.log(logOutFlg, "logOutFlg")
            state.logOutFlg = logOutFlg
        },
        // 审批点击
        setApprovalActive(state, active) {
            state.approvalActive = active
        },
    },
    actions: { // 异步接收 dispatch
        setActiveIndex(content, activeIndex) {
            content.commit('setActiveIndex', activeIndex)
        },
        setAndroidUrl(content, url) {
            content.androidUrl = url
            content.commit('setAndroidUrl', url)
        },
        // 登入 token
        setToken(content, token) {
            content.commit('setToken', token)
        },
        // 退出 token
        removeToken(content, token) {
            content.commit('removeToken', token)
        },
        // 存储权限数组
        setPermissions(content, arr) {
            content.commit('setPermissions', arr)
        },
        // 清除权限数组
        clearPermissions(content, arr) {
            content.commit('clearPermissions', arr)
        },
        // 存入登录名称
        setLoginName(content, userName) {
            content.commit('setLoginName', userName)
        },
        // 清除权登录名称
        clearLoginName(content, userName) {
            content.commit('clearLoginName', userName)
        },
        // 存入店铺信息
        setStoreInfo(content, storeInfo) {
            content.commit('setStoreInfo', storeInfo)
        },
        // 清除权店铺名称
        clearStoreInfo(content, storeInfo) {
            content.commit('clearStoreInfo', storeInfo)
        },
        // 存入用户头像
        //  setUserPhoto (content, userPhoto) {
        //   content.commit('setUserPhoto', userPhoto)
        // },
        // 清除权限数组
        clearUserPhoto(content, userPhoto) {
            content.commit('clearUserPhoto', userPhoto)
        },
        // 用户真名
        setRealName(content, realName) {
            content.commit('setRealName', realName)
        },
        // 清除用户真名
        clearRealName(content, realName) {
            content.commit('clearRealName', realName)

        },
        setDrafs(content, drafs) {
            content.commit('setDrafs', drafs)
        },
        addDraf(content, data) {
            content.commit('addDraf', data)
        },
        removeDraf(content, uuid) {
            content.commit('removeDraf', uuid)

        },
        // 存储未读消息条数
        setMessageNum(content, num) {
            content.commit('setMessageNum', num)
        },
        // 清除未读消息条数
        removeMessageNum(content, num) {
            content.commit('removeMessageNum', num)
        },
        // 登录店员的id
        setLoginStaffId(content, staffId) {
            content.commit('setLoginStaffId', staffId)
        },
        // BossId
        setLoginBossId(content, bossId) {
            content.commit('setLoginBossId', bossId)
        },
        // 通知刷新
        setStoreList(content, storelist) {
            content.commit('setStoreList', storelist)
        },
        setSocket(content, socket) {
            content.commit("setSocket", socket)
        },
        setSocketState(content, socketState) {
            content.commit("setSocketState", socketState)
        },
        setlogOutFlg(content, logOutFlg) {
            content.commit("setlogOutFlg", logOutFlg)
        },
        // 经济看板type
        setGloblaViewType(content, globlaViewType) {
            content.commit("setGloblaViewType", globlaViewType)
        },
        setLogisticsDate(content,logisticsDate){
            content.commit("setLogisticsDate", logisticsDate)
        },
        setRiderStatisticsDate(content,riderStatisticsDate){
            content.commit("setRiderStatisticsDate", riderStatisticsDate)
        },
        setSortingCenterDate(content,sortingCenterDate){
            content.commit("setSortingCenterDate", sortingCenterDate)
        },
        setTransferWarehouseDate(content,transferWarehouseDate){
            content.commit("setTransferWarehouseDate", transferWarehouseDate)
        },
        // 审批点击
        setApprovalActive(content, active) {
            content.commit("setApprovalActive", active)
        },
    },
    modules: {}
})


// WEBPACK FOOTER //
// ./src/store/index.js